export class UserLogin {
    Email: string;
    Password: string;

    constructor(Email: string, Password: string) {
        this.Email = Email;
        this.Password = Password;
    }
}



// WEBPACK FOOTER //
// ./src/app/login/user-login.ts